import type { Annotation } from '../../../types/health-data'
import { AbstractState, type RequestStatus } from '../../types'

export interface Facility {
  id?: number
  name: string
  reference: string
  geographicFiness: string | null
}

export interface Division {
  id?: number
  title: string
  reference: string
  facility: Facility | null
}

export interface MedicalUnit {
  id?: number
  title: string
  reference: string
  facilityDivision: Division | null
}

export interface Constant {
  id: number
  description: string
  max: string
  min: string
}

export type RemoteListNamedEntity = Pick<Annotation, 'namedEntityConfigId' | 'namedEntityName'>

export class RemoteListsState extends AbstractState {
  facilities: Facility[]
  divisions: Division[]
  medicalUnits: MedicalUnit[]
  namedEntities: RemoteListNamedEntity[]
  constants: Constant[]
  completionItems: []
  biologyValues: []
  hasDrugs?: boolean
  hasHealthConstantss?: boolean
  hasBiologyResults?: boolean
  completionRequest: RequestStatus
  medicalUnitsRequest: RequestStatus
  constantsRequest: RequestStatus
  dataPresenceRequest: RequestStatus
  biologyValuesRequest: RequestStatus
}
